export { default } from "./TeacherPage";
